export const wellKnownPetnames = {
  IbcATOM: 'ATOM',
};
